import { render, staticRenderFns } from "./UbahProvinsi.vue?vue&type=template&id=b2ca8790&scoped=true"
import script from "./UbahProvinsi.vue?vue&type=script&lang=js"
export * from "./UbahProvinsi.vue?vue&type=script&lang=js"
import style0 from "./UbahProvinsi.vue?vue&type=style&index=0&id=b2ca8790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ca8790",
  null
  
)

export default component.exports